import * as React from 'react';
import './css/app.css';
import MainHeader from './components/MainHeader';
import MainLogin from './components/MainLogin';
import MainForm from './components/MainForm';
import MainFooter from './components/MainFooter';
import ApiAuth from './code/api/ApiAuth';
import Auth from './code/auth/Auth';
import AuthAdminUserModel from './code/models/AuthAdminUserModel';
import Api_Config from './code/api/ApiConfig';
import AdminMainForm from './components/admin/AdminMainForm';
import AdminUserForm from "./components/admin/AdminUserForm";

function App() {
  const [currentUser, setCurrentUser] = React.useState<AuthAdminUserModel>();
  const [currentPage, setCurrentPage] = React.useState<string>("main");
  const [currentSubPage, setCurrentSubPage] = React.useState<string>("");

  React.useEffect(() => {
    updateCurrentUserFromToken();
    Auth.subscribeForUnathorizedRequest(handleLogOff);
    Api_Config.getSelectedCompany();
  }, []);

  function updateCurrentUserFromToken() {
    const cUser = Auth.getDecodedToken();
    if (!!cUser) {
      setCurrentUser(cUser);
    }
  }

  function handleLogOff() {
    ApiAuth.logout().then(r => {
      setCurrentUser(undefined);
    });
  }

  function handleCompanyChanged() {
    updateCurrentUserFromToken();
  }

  function handleSelectPage(page: string): void {
    setCurrentPage(page);
  }

  function handleSelectSubPage(subPage: string): void {
    setCurrentSubPage(subPage);
  }

  function getLoginPage(): React.ReactNode {
    return (
      <MainLogin onLogin={updateCurrentUserFromToken} />
    )
  }

  function getMainPage() {
    if (!currentUser) return null;
    return (
      <React.Fragment>
        {currentPage === "admin" && <AdminMainForm adminUser={currentUser} currentPage={currentSubPage} />}
        {currentPage === "my-profile" && <AdminUserForm adminUser={currentUser} />}
        {currentPage === "main" && <MainForm currentAdminUser={currentUser} key={"main-content-" + (currentUser?.cid ?? currentUser?.company)} />}
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <MainHeader currentUser={currentUser} onLogoff={handleLogOff} onCompanyChanged={handleCompanyChanged}
        onSelectPage={handleSelectPage} onSelectSubPage={handleSelectSubPage} currentPage={currentPage} key={"mainheader" + currentPage} />
      {!currentUser ? getLoginPage() : getMainPage()}
      <MainFooter />
    </React.Fragment>
  );
}

export default App;
